import Container from './Studio.container';
import Studio from './Studio';

export default Container(Studio);
